import React, { useRef } from 'react'
import ReactSignatureCanvas from 'react-signature-canvas'
import useCustomToast from '../../../hooks/useCustomToast';

function SignaturePad({ setFile }: { setFile: any }) {
    const signatureRef: any = useRef(null);

    const customToast = useCustomToast()

    const dataURLtoFile = (dataURL: any, filename: string) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };


    const handleSignature = async (e: React.FormEvent) => {
        e.preventDefault()
        const image = signatureRef?.current?.getTrimmedCanvas().toDataURL('image/png');
        const signatureFile = dataURLtoFile(image, 'signature.png');
        setFile(signatureFile)
        customToast("Signature has been set", "success")
    }


    const handleClearSignature = (e: React.FormEvent) => {
        e.preventDefault()
        signatureRef.current.clear();
        setFile(null);
    };

    return (
        <div className="singnature">
            <ReactSignatureCanvas
                penColor="#000"
                backgroundColor="#F8FAFB"
                ref={signatureRef}
                canvasProps={{
                    width: 500,
                    height: 169,
                    className: "sigCanvas",
                }}
            />
            <div className=" d-flex gap-2">
                <button
                    className="btn btn-sm btn-danger"
                    onClick={handleClearSignature}
                >
                    Clear
                </button>
                <button
                    className="btn btn-sm btn-primary"
                    onClick={handleSignature}
                >
                    Set this signature
                </button>
            </div>
        </div>
    )
}

export default SignaturePad